import { render, staticRenderFns } from "./productiveTimeSector.vue?vue&type=template&id=a53aa6a0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./productiveTimeSector.vue?vue&type=style&index=0&id=a53aa6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53aa6a0",
  null
  
)

export default component.exports